import React, { useState, useCallback, useMemo, useEffect } from 'react';
import { Container, Box, Grid, Tabs, Tab } from '@mui/material';
import CodeEditor from '../feed_builder/CodeEditor';
import FeedResults from '../feed_builder/FeedResults';
import { generateCode } from '../feed_builder/code_generator';      
import { useGlobal } from '../contexts/GlobalContext';
import { useBuild } from '../contexts/BuildContext';       
  

const FeedBuilder = () => {
  const [tab, setTab] = useState(0);
  const [logs, setLogs] = useState([]);
  const [results, setResults] = useState(null);
  const { setCurrentContext, mergeCurrentContext } = useGlobal();
  const { searchLastCall, featuresLastCall, scoringLastCall, rankingLastCall, hydrationLastCall } = useBuild();

  useEffect(() => {
    setCurrentContext({
      product: 'build',
      page: 'sdk',
    });
    return () => setCurrentContext(null);
  }, [setCurrentContext]);

  useEffect(() => {
    mergeCurrentContext({ sdkTab: tab === 0 ? 'Results' : 'Logs' });
  }, [tab, mergeCurrentContext]);

  const code = useMemo(() => {
    return generateCode(searchLastCall, featuresLastCall, scoringLastCall, rankingLastCall, hydrationLastCall);
  }, [searchLastCall, featuresLastCall, scoringLastCall, rankingLastCall, hydrationLastCall]);

  const clearResults = useCallback(() => {
    setResults(null);
  }, []);

  const clearLogs = useCallback(() => {
    setLogs([]);
  }, []);

  const appendLog = useCallback((text) => {
    setLogs((prev) => [...prev, String(text)]);
  }, []);

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  return (
    <Container maxWidth="xl" sx={{ mt: 2 }}>
      <Grid container spacing={2} sx={{ width: '100%', alignItems: 'flex-start' }}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              border: '1px dashed',
              borderColor: 'divider',
              borderRadius: 1,
              bgcolor: 'grey.50',
              overflow: 'hidden',
            }}
          >
            <CodeEditor
              initialCode={code}
              clearResults={clearResults}
              clearLogs={clearLogs}
              appendLog={appendLog}
              setLogs={setLogs}
              setResults={setResults}
            />
          </Box>
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              minHeight: 'calc(100vh - 120px)',
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: 1,
              overflow: 'hidden',
            }}
          >
            <Tabs value={tab} onChange={handleTabChange}>
              <Tab label="Results" />
              <Tab label="Logs" />
            </Tabs>
            <Box sx={{ flex: 1, p: 2, bgcolor: 'background.paper', overflow: 'auto' }}>
              {tab === 0 && <FeedResults data={results} />}
              {tab === 1 && (
                <Box component="pre" sx={{ m: 0, fontSize: 12, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                  {logs.length === 0 ? 'No logs yet.' : logs.join('\n')}
                </Box>
              )}
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default FeedBuilder;
